import { styled } from '@mui/material';
import { Grid, Typography, withDefaultProps } from '@kc-console/common-ui';

import { useDataTableContext } from '../../context/DataTableContext';
import { EllipsisText } from '../EllipsisText';
import { RouterLink } from '../RouterLink';

import type { MouseEvent } from 'react';
import type { PropsWithClassName, PropsWithStyle } from '@kc-console/common-ui';

export interface NameCellProps extends PropsWithClassName, PropsWithStyle {
  name: string;
  /**
   * @default false
   */
  external?: boolean;
  href?: string;
  onNameClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export default function NameCell(props: NameCellProps) {
  const { name, href, onNameClick, external = false, className, style } = props;

  const { textEllipsis } = useDataTableContext();

  const NameCellNameText = textEllipsis ? NameCellNameTextEllipsis : NameCellNameTextWrap;

  return (
    <NameCellRoot container flexDirection="column" className={className} style={style}>
      <NameCellName
        component={href ? RouterLink : undefined}
        href={href}
        external={href ? external : undefined}
        variant="label/regular/md"
        onClick={onNameClick}
        display={textEllipsis ? 'inline-flex' : 'inline'}
      >
        <NameCellNameText variant="inherit">{name}</NameCellNameText>
      </NameCellName>
    </NameCellRoot>
  );
}

const NameCellRoot = styled(Grid)``;

const NameCellName = styled(Typography)<Pick<NameCellProps, 'href' | 'external'>>`
  width: 100%;
  align-items: center;
`;

const NameCellNameTextEllipsis = styled(EllipsisText)`
  flex-shrink: 1;
  min-width: 0;
`;

const NameCellNameTextWrap = styled(withDefaultProps(Typography, { component: 'span' }))`
  white-space: wrap;
`;
